import { useQuery } from '@tanstack/react-query';
import { api } from '../../../shared/api.js';

const GROUP_LABELS = {
  dashboard: 'اللوحة الرئيسية',
  reception: 'الاستقبال',
  active: 'الأطفال داخل القاعة',
  gates: 'البوابات',
  pos: 'نقاط البيع',
  checkout: 'المحاسبة والخروج',
  pricing: 'التسعير',
  inventory: 'المخزون',
  cashbox: 'القاصات',
  finance: 'المالية',
  reports: 'التقارير',
  settings: 'الإعدادات',
  general: 'عام'
};

// يحوّل ناتج الخادم (الذي قد يكون object مفهرس بالمجموعة أو array) إلى
// شكل موحّد: Array<{ key, name, perms: [{ key, label }] }>.
function normalizeGroups(data) {
  if (!data) return [];
  const raw = data.groups ?? data.permissions ?? data;
  if (Array.isArray(raw)) {
    return raw.map((g) => ({
      key: g.key || g.name || g.group || 'general',
      name: g.label || g.name || GROUP_LABELS[g.key || g.group] || g.key || 'عام',
      perms: g.perms || g.permissions || []
    }));
  }
  if (typeof raw === 'object') {
    return Object.entries(raw).map(([key, perms]) => ({
      key,
      name: GROUP_LABELS[key] || key,
      perms: Array.isArray(perms) ? perms : []
    }));
  }
  return [];
}

export function usePermissions() {
  return useQuery({
    queryKey: ['settings', 'permissions'],
    queryFn: async () => {
      const { data } = await api.get('/permissions');
      return normalizeGroups(data);
    },
    staleTime: 5 * 60_000
  });
}

// صلاحيات مستخدم بعينه (لتعبئة المصفوفة عند فتح نموذج التعديل).
export function useUserPermissions(userId, enabled = true) {
  return useQuery({
    queryKey: ['users', userId, 'permissions'],
    enabled: !!userId && enabled,
    queryFn: async () => {
      const { data } = await api.get(`/users/${userId}/permissions`);
      return Array.isArray(data?.permissions) ? data.permissions : [];
    }
  });
}
